<div class="body" #body>

    <div class="body-inner">

        <div class="header">

            <div class="rootMetaData">

                <span class="name">{{rootName$|async}}</span>

                <span *ngIf="(files$|async)?.length === 1; else plural">Eine Datei,</span>

                <ng-template #plural>
                    <span class="count">{{(files$|async)?.length}}</span>
                    <span>Dateien,</span>
                </ng-template>

                <span class="size">{{prettyRootSize$|async}}</span>

            </div>

            <app-nextcloud-path-navigator 
                (pathChanged)="pathNavigatorChanged($event)" 
                [pathArray]="rootPathArray$|async" 
                [enableNavigation]=enableNavigation></app-nextcloud-path-navigator>
        
        </div>

        <div class="content">

            <app-nextcloud-explorer 
                (onFileClick)="fileClick($event)" 
                [files]="files$|async" 
                [filter]="fileFilter" 
                [enableNavigation]=enableNavigation
                [loading]="loading$|async" 
                [view]="viewMode"
            ></app-nextcloud-explorer>

        </div>

    </div>

</div>
